module.exports = __webpack_public_path__ + "files/8cbc54b04b06e2dabfca4884b5770459.png";